
import {defineComponent} from "vue";
import ContentAnnotationForm from "./ContentAnnotationForm.vue";
import ContentAnnotationList from "./ContentAnnotationList.vue";

export default defineComponent({
  name: "ContentAnnotation",
  components: { ContentAnnotationList, ContentAnnotationForm },
});
